import get from 'lodash/get';
import commonConfig from '../config';
import mapConfigResponse from './data/mapConfigResponse';

const { configCommands } = commonConfig;

export const CONFIG_INIT = 'CONFIG_INIT';
export const FETCH_CONFIG = 'FETCH_CONFIG';

export function mapConfigFetchResponse(experimentOverrides) {
  return ({ data: configData = {} }) => ({
    config: mapConfigResponse(configCommands, configData, experimentOverrides),
  });
}

export function configInit(configResponse, experimentOverrides) {
  return {
    type: CONFIG_INIT,
    ...mapConfigFetchResponse(experimentOverrides)(configResponse),
  };
}

export function fetchConfig() {
  return (dispatch, getState) => {
    const cachedExperimentOverrides = get(
      getState(),
      'config.experimentOverrides',
      {},
    );

    return dispatch({
      type: FETCH_CONFIG,
      api: {
        endpoint: ['config', 'get'],
        args: [
          {
            c: configCommands,
            render: 'json',
          },
        ],
        transform: mapConfigFetchResponse(cachedExperimentOverrides),
      },
    });
  };
}
